const LoadingMessage = () => (
  <div>
    <div className="loaderWrp">
      <div className="loader"></div>
    </div>
  </div>
);

export default LoadingMessage;
